import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckCircle = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        d="M12 22a9.97 9.97 0 0 0 7.071-2.929A9.97 9.97 0 0 0 22 12a9.969 9.969 0 0 0-2.929-7.071A9.969 9.969 0 0 0 12 2a9.969 9.969 0 0 0-7.071 2.929A9.969 9.969 0 0 0 2 12a9.969 9.969 0 0 0 2.929 7.071A9.969 9.969 0 0 0 12 22Z"
        fill="#004744"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.399 4.399A10.719 10.719 0 0 1 12 1.25c2.968 0 5.657 1.204 7.601 3.149l-.53.53.53-.53A10.719 10.719 0 0 1 22.75 12c0 2.968-1.204 5.657-3.149 7.601A10.719 10.719 0 0 1 12 22.75a10.719 10.719 0 0 1-7.601-3.149l.53-.53-.53.53A10.719 10.719 0 0 1 1.25 12c0-2.968 1.204-5.657 3.149-7.601ZM12 2.75a9.219 9.219 0 0 0-6.54 2.71A9.219 9.219 0 0 0 2.75 12a9.219 9.219 0 0 0 2.71 6.54A9.219 9.219 0 0 0 12 21.25a9.218 9.218 0 0 0 6.54-2.71A9.218 9.218 0 0 0 21.25 12a9.219 9.219 0 0 0-2.71-6.54A9.219 9.219 0 0 0 12 2.75Z"
        fill="#004744"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.53 8.47a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06L11 13.94l5.47-5.47a.75.75 0 0 1 1.06 0Z"
        fill="#fff"
      />
    </SvgIcon>
  )
}

export default CheckCircle
